import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { HeaderNavProps } from '../interfaces';
import HeaderNavLink from './HeaderNavLink';
import HeaderNavLogo from './HeaderNavLogo';
import HeaderShopMenu from './HeaderShopMenu';
import useHeaderShopMenu from './useHeaderShopMenu';
import './headerNav.scss';

const HeaderNav: React.FC<HeaderNavProps> = ({ types, className }) => {
  const location = useLocation();
  const list = useMemo(() => types ?? [], [types]);
  const shopMenu = useHeaderShopMenu(location.pathname, location.search);

  return (
    <nav
      className={`header-nav ${className ?? 'custom-menu'}`}
      aria-label="Main navigation"
    >
      <HeaderNavLogo isActive={location.pathname === '/'} />
      <HeaderShopMenu
        types={list}
        shopOpen={shopMenu.shopOpen}
        shopGender={shopMenu.shopGender}
        currentGender={shopMenu.currentGender}
        currentType={shopMenu.currentType}
        isProductsPage={location.pathname === '/products'}
        usesHoverMenu={shopMenu.usesHoverMenu}
        onOpen={shopMenu.openShopMenu}
        onClose={shopMenu.closeShopMenu}
        onScheduleClose={shopMenu.scheduleShopClose}
        onToggle={shopMenu.toggleShopMenu}
        onGenderChange={shopMenu.setShopGender}
      />
      <HeaderNavLink to="/about-us" isActive={location.pathname === '/about-us'}>
        About Us
      </HeaderNavLink>
      <HeaderNavLink to="/help" isActive={location.pathname === '/help'}>
        Help
      </HeaderNavLink>
    </nav>
  );
};

export default HeaderNav;
